import type { ReactNode } from "react";
import { Text } from "~/components/Text";
import RedFlowerImage from "~/images/red-flower.png";

export function FlowerCallout({ title, children, label }: {
  title?: string;
  children: ReactNode;
  label?: string;
}) {
  return (
    <section aria-label={label} className="flex items-center gap-3 rounded-lg border border-butter-cream bg-butter-cream/35 px-3 py-[13px]">
      <img src={RedFlowerImage} alt="" width={30} height={25} className="h-[25px] w-[30px] shrink-0 object-contain" />
      <div className="min-w-0 flex-1">
        {title && <Text as="h3" size="sm" color="pink" className="mb-1.5">{title}</Text>}
        <Text size="sm">{children}</Text>
      </div>
    </section>
  );
}
